import React from 'react'
import { Heading } from '@enterprise-ui/canvas-ui-react'

interface IValidationContent {
  classification: string
  description: string
  message: string
  name: string
  status: string
  value: string
}
const FileValidationPopoverContent = ({ validationContent }: { validationContent: string }) => {
  const JSONValidationContent: IValidationContent[] = JSON.parse(validationContent)
  return (
    <>
      {JSONValidationContent.map((content: IValidationContent) => {
        return (
          <p className="hc-pb-dense hc-mb-dense" key={content.name}>
            <Heading size={4} className="hc-clr-error hc-pb-dense">
              {content.name}
            </Heading>
            <strong className="hc-clr-error">Description: </strong> {content.description}
            <br />
            <strong className="hc-clr-error">Validation message: </strong> {content.message}
          </p>
        )
      })}
    </>
  )
}

export default FileValidationPopoverContent
